export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '每日大赛是什么？',
    answer: '每日大赛是一个在线竞技赛事平台，每天更新不同类型的比赛项目，涵盖知识竞赛、脑力竞技、创意大赛、运动挑战、游戏竞技和音乐比赛等多个领域。参赛者通过参与比赛获得积分，赢取丰厚奖品和荣耀排名。',
  },
  {
    question: '如何报名参加每日大赛？',
    answer: '注册每日大赛账号后，在首页选择您感兴趣的比赛类别，点击"立即参与"即可进入比赛页面。每天的比赛项目都会自动更新，无需额外报名。首次参与建议先查看比赛规则和计分方式。',
  },
  {
    question: '参加比赛需要付费吗？',
    answer: '每日大赛的基础赛事完全免费参与！我们提供免费赛道供所有用户参赛。同时也有VIP赛道提供更高额度的奖励和专属赛事，VIP会员可以享受双倍积分日、优先兑换等特权。但免费用户同样可以获得丰厚的积分和奖品。',
  },
  {
    question: '积分有什么用途？',
    answer: '积分是每日大赛的核心奖励系统。积分可以用于：1）在积分商城兑换实物奖品（电子产品、图书礼券等）；2）提升排行榜排名获得荣誉；3）解锁VIP等级享受更多特权；4）参与限定赛事和活动。积分有效期为获得后12个月。',
  },
  {
    question: '每天的比赛时间是多久？',
    answer: '大多数比赛项目每天只需10-30分钟即可完成。例如知识竞赛每天10-20题，脑力竞技每天1-3个挑战关卡，运动挑战每天20-30分钟训练任务。您可以根据自己的时间灵活安排，比赛项目全天24小时可参与。',
  },
  {
    question: '排行榜是如何计算的？',
    answer: '排行榜分为日榜、周榜和月榜三种。日榜统计当天的比赛积分，每天零点刷新；周榜统计本周累计积分，每周一刷新；月榜统计本月累计积分，每月1日刷新。排名依据积分高低，积分相同时按参赛次数和连续参赛天数排序。',
  },
  {
    question: '可以同时参加多个类别的比赛吗？',
    answer: '当然可以！每日大赛鼓励参赛者探索不同领域的竞技挑战。您可以在同一天参与知识竞赛、运动挑战、创意大赛等多个类别的比赛，每个类别的积分独立计算，最终汇总到您的总积分中。',
  },
  {
    question: '如何保证比赛的公平性？',
    answer: '每日大赛采用多重机制保障比赛公平性：1）AI智能防作弊系统实时监控异常行为；2）人工审核团队抽查可疑成绩；3）所有比赛数据和排名公开透明可查询；4）举报机制，用户可举报可疑行为。一经查实作弊行为，将取消成绩并封禁账号。',
  },
];